import dashboardIcon from '../icons/logo-streamlines.png';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { HiOutlineBars3, HiOutlineXMark } from 'react-icons/hi2';

export default function TopHeader(props: {
  signOut: any;
  nav?: ReactElement;
  toggleSideBar: () => void;
  toggleMobileSideBar: () => void;
  showMobileSideBar?: boolean;
}): ReactElement {
  const { nav, toggleSideBar, toggleMobileSideBar, showMobileSideBar } = props;
  const [userProfile] = useUser();

  return (
    <header
      className="cr-relative cr-sticky cr-top-0 cr-z-5000 cr-flex
      cr-h-10 cr-w-screen cr-items-center cr-bg-cirrusBlue-400 cr-shadow-md"
    >
      <div className="cr-mx-4 cr-hidden cr-text-white sm:cr-block" onClick={() => toggleSideBar()}>
        <HiOutlineBars3 className={'cr-size-7'} />
      </div>
      <div className="cr-mx-4 cr-block cr-text-white sm:cr-hidden" onClick={() => toggleMobileSideBar()}>
        <div className={'cr-size-7'}>
          {showMobileSideBar ? <HiOutlineXMark className={'cr-size-7'} /> : <HiOutlineBars3 className={'cr-size-7'} />}
        </div>
      </div>

      <Link to={'/'} className={'cr-h-[30px] sm:cr-h-[42px]'}>
        <img className={'cr-h-[30px] sm:cr-mx-1.5 sm:cr-h-[42px] '} src={dashboardIcon} alt="Dashboard icon" />
      </Link>

      {nav ?? (
        <h3 className={'font-forma cr-text-sm cr-text-white sm:cr-text-xl'}>
          <span className={'cr-mr-2'}>|</span>
          {userProfile && userProfile.user_role > 0 ? (
            <>
              <span className="cr-text-nowrap">{userProfile.show_config ? 'CIRRUS' : 'RIDER'}</span> Portal
            </>
          ) : (
            <>Loading user...</>
          )}
        </h3>
      )}
    </header>
  );
}
